import { useMemo, useRef, useState } from "react";
import LoadingComponent from "../../../widgets/LoadingComponent";
import ReactQuill from "react-quill";
import { Breadcrumb, Button, FloatingLabel, Form } from "react-bootstrap";
import { FaSave } from "react-icons/fa";
import { postData } from "../../../api/ApiRest";
import auditoriaSet from "../../../widgets/Auditoria";
import { useNavigate, useParams } from "react-router-dom";

function NovedadCrud() {
    const [loading, setLoading] = useState(false);
    const [infoNovedad, setInfoNovedad] = useState({});

    const navigate = useNavigate();

    const id = useParams().id;

    ///Ref que se utiliza para el texto enriquecido
    const quillRef = useRef(null);

    const toolbarOptions = useMemo(
        () => [
            [{ header: [1, 2, 3, 4, 5, 6, false] }],
            ["bold", "italic", "underline", "strike", "blockquote"],
            [{ list: "ordered" }, { list: "bullet" }, { indent: "-1" }, { indent: "+1" }],
            [{ align: [] }],
            [{ color: [] }, { background: [] }],
            [{ font: [] }, { size: [] }],
            ["link", "image", "video"],
            ["clean"],
        ],
        []
    );

    //Formatos permitidos en el texto enriquecido
    const formats = [
        "header",        // Encabezados
        "bold", "italic", "underline", "strike", "blockquote",
        "list", "bullet", "indent",
        "link", "image", "video", // Multimedia
        "color", "background",    // Colores
        "align", "font", "size"   // Alineación, fuentes y tamaños
    ];

    ///Modulos o propiedades que aparecen en el titulo enriquecido
    const modules = useMemo(
        () => ({
            toolbar: {
                container: toolbarOptions
            },
        }),
        [toolbarOptions]
    );

    const guardarNovedades = () => {
        setLoading(true);

        if (id !== ':id'){
            alert('No puedes modificar una novedad');
            setLoading(false);
            return;
        }

        let objeto = {
            titulo: infoNovedad.titulo,
            tipo: infoNovedad.tipo,
            fecha: infoNovedad.fecha,
            texto: infoNovedad.descripcion
        };

        postData('api/Configuracion/Novedad/creaNovedad', {}, objeto).then(response => {
            alert('Novedad creada con éxito');
            auditoriaSet(objeto, {}, 'C', 'Novedad', '', 'CreaNov');
            navigate('/Home/NovedadesCrud/' + response.objeto.novedadid);

            setLoading(false);
        }, error => {
            console.log(error);
            setLoading(false);
        });
    }

    return <div className='BodyComponent'>
        <Breadcrumb>
            <Breadcrumb.Item style={{ fontSize: 14 }} >Home</Breadcrumb.Item>
            <Breadcrumb.Item style={{ fontSize: 14 }} href="/Home/Novedades">Novedades</Breadcrumb.Item>
            <Breadcrumb.Item style={{ fontSize: 14 }} active={true}>Nueva novedad</Breadcrumb.Item>
        </Breadcrumb>

        {<LoadingComponent Loading={loading} />}

        <div className="row">
            <div className="col-md-4">
                <FloatingLabel
                    controlId="Titulo"
                    label="Titulo"
                    className="form-floating-sm mb-3"
                >
                    <Form.Control
                        size='sm'
                        type="text"
                        autoComplete='off'
                        placeholder="Titulo"
                        value={infoNovedad.titulo}
                        onChange={event => {
                            setInfoNovedad({ ...infoNovedad, titulo: event.target.value })
                        }}
                        className="input-fecha-sm"
                    />
                </FloatingLabel>
            </div>
            <div className="col-md-2">
                <FloatingLabel
                    controlId='Tipo'
                    label="Tipo"
                    className="form-floating-sm mb-2"
                >
                    <Form.Select
                        value={infoNovedad.tipo}
                        onChange={event => {
                            setInfoNovedad({ ...infoNovedad, tipo: event.target.value })
                        }}
                        className="input-fecha-sm"
                    >
                        <option value="">Seleccione</option>
                        <option value="A">Actualizaciones</option>
                        <option value="M">Mejoras</option>
                        <option value="N">Noticias</option>
                    </Form.Select>
                </FloatingLabel>
            </div>
            <div className="col-md-3">
                <FloatingLabel
                    controlId="Fecha"
                    label="Fecha"
                    className="form-floating-sm mb-3"
                >
                    <Form.Control
                        size='sm'
                        type="date"
                        placeholder="Fecha"
                        value={infoNovedad.fecha}
                        onChange={event => {
                            setInfoNovedad({ ...infoNovedad, fecha: event.target.value })
                        }}
                        className="input-fecha-sm"
                    />
                </FloatingLabel>
            </div>
            <div className="col-md-1">
                <Button size="sm" title="Guardar novedades" variant="success" onClick={() => guardarNovedades()}>
                    <FaSave size={'0.8rem'} />
                </Button>
            </div>
        </div>

        <div className="row">
            <ReactQuill
                ref={quillRef}
                theme="snow"
                value={infoNovedad.descripcion}
                onChange={(content) => setInfoNovedad({ ...infoNovedad, descripcion: content })}
                modules={modules}
                style={{
                    height: "400px",
                    maxHeight: "400px",
                }}
                formats={formats} />
        </div>
    </div>
}

export default NovedadCrud;